"use client";

import { type ReactNode, createContext, useContext } from "react";
import type { FeatureFlagMap } from "./feature-flags";

// Defaults to empty so a component rendered outside the provider fails closed.
const FeatureFlagsContext = createContext<FeatureFlagMap>({});

export const FeatureFlagsProvider = ({
	flags,
	children,
}: {
	flags: FeatureFlagMap;
	children: ReactNode;
}) => (
	<FeatureFlagsContext.Provider value={flags}>
		{children}
	</FeatureFlagsContext.Provider>
);

export const useFeatureFlags = (): FeatureFlagMap =>
	useContext(FeatureFlagsContext);

export const useFeatureFlag = (slug: string): boolean =>
	useContext(FeatureFlagsContext)[slug] === true;
